import { render, staticRenderFns } from "./InvoicingIndex.vue?vue&type=template&id=8465dab0&"
import script from "./InvoicingIndex.vue?vue&type=script&lang=js&"
export * from "./InvoicingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports